import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sizes } from '@ratehub/base-ui';
import classNames from 'classnames';


function BrokerHoursBlock({
    shouldShowTitle = false,
    hours,
    isLargeText = false,
    className = '',
}) {
    return (
        <div className={className}>
            <If condition={shouldShowTitle}>
                <p className="rh-text-m weight-medium rh-mt-0 rh-mx-0 rh-mb-one">
                    <FormattedMessage
                        id="InsCommon.BrokerHoursBlock.title"
                        defaultMessage="Hours of operation"
                    />
                </p>
            </If>

            <StyledGrid
                className={classNames(
                    {
                        'rh-text-s': !isLargeText,
                        'rh-text-l': isLargeText,
                    },
                    'rh-display-grid',
                )}
            >
                <For
                    each="hoursRow"
                    of={hours}
                >
                    {/*
                    This text comes from the CMS.
                    FR translations are handled there as well.
                    profile-service automatically gives the correct language in the same shape
                    */}
                    <span className="weight-medium">
                        {hoursRow.days}
                        {':'}
                    </span>
                    <span>
                        {hoursRow.hours}
                    </span>
                </For>
            </StyledGrid>
        </div>
    );
}

BrokerHoursBlock.propTypes = {
    shouldShowTitle: PropTypes.bool,
    hours: PropTypes.arrayOf(PropTypes.shape({
        days: PropTypes.string.isRequired,
        hours: PropTypes.string.isRequired,
    })).isRequired,
    isLargeText: PropTypes.bool,
    className: PropTypes.string,
};

const StyledGrid = styled.div`
    grid-template-columns: auto auto;
    gap: ${Sizes.SPACING.HALF};
    width: fit-content;
`;

export default BrokerHoursBlock;
